import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Ally } from "../../mechanics/ally/Ally"
import { allies } from "../../mechanics/AllyMechanic"

interface IinitialState {
    allies: Ally[]
    activeId: string
    activeAllyIndex: number
    isAllyActive: boolean
}

const initialState: IinitialState = {
    allies: [],
    activeId: '',
    activeAllyIndex: 0,
    isAllyActive: false
}

export const campSlice = createSlice({
    name: "camp",
    initialState,
    reducers: {
        setAllies(state, action: PayloadAction<Ally[]>) {
            state.allies = action.payload
        },
        setActiveId(state, action: PayloadAction<string>) {
            state.activeId = action.payload
        },
        setAllyActiveIndex(state, action: PayloadAction<number>) {
            state.activeAllyIndex = action.payload
        },
        setIsAllyActive(state) {
            state.isAllyActive = !state.isAllyActive
        }
    }
})

export default campSlice.reducer

// const allies = (state: RootState) => state().campReducer.allies
// const activeId = (state: RootState) => state().campReducer.activeId
// const activeIndex = (state: RootState) => state().campReducer.activeIndex

// export const alliesSelector = createSelector(
//     allies,
//     activeIndex,
//     (allies, activeIndex) => {
//         return allies[activeIndex]
//     }
// )